<template>
  <div style="padding: 10px">
    <el-page-header @back="goBack"/>
    <div class="box_down">
      <template v-if="smartPavilions.length > 0">
        <el-card v-for="pavilion in smartPavilions" :key="pavilion.id" class="box-card"
                 @click.native="goSmartPavilionDetails(pavilion)">
          <div class="teacherInfo relative">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-avatar
                  shape="square"
                  :size="windowInnerWidth * 0.3"
                  :src="pavilion.imgUrl"
                ></el-avatar>
              </el-col>
              <el-col :span="18">
                <el-row :gutter="10" style="margin:10px;">
                  <el-col :span="8" style="text-align:right;">名称</el-col>
                  <el-col :span="16" style="text-align:left;font-weight:bold;">{{ pavilion.pavilionName }}</el-col>
                </el-row>
                <el-row :gutter="10" style="margin:10px;">
                  <el-col :span="8" style="text-align:right;">地点</el-col>
                  <el-col :span="16" style="text-align:left;font-weight:bold;">{{ pavilion.pavilionPlace }}
                  </el-col>
                </el-row>
                <el-row :gutter="10" style="margin:10px;">
                  <el-col :span="8" style="text-align:right;">开放时间</el-col>
                  <el-col :span="16" style="text-align:left;font-weight:bold;">
                    {{ findContinuousTimeSlots(pavilion.scheduling.timeSlot) }}
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </template>
      <el-empty v-else description="暂无数据"/>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {goBack} from "@/assets/js/consult";
import HttpRequest from "@/utils/request";
import {findContinuousTimeSlots} from "@/assets/js/pavilion";

export default {
  data() {
    return {
      smartPavilions: [],
      windowInnerWidth: 0
    }
  },
  computed: {
    ...mapState({
      student: (state) => state.user.student,
    }),
  },
  mounted() {
    this.windowInnerWidth = window.innerWidth
    document.title = '面试亭预约'
    this.getSmartPavilions();
  },
  methods: {
    findContinuousTimeSlots,
    goBack,
    getSmartPavilions() {
      let url = "/constub/smartPavilion/getSmartPavilions";
      let data = {token: this.student.token};
      HttpRequest.requestFormPost(url, data).then((res) => {
        if (res && res.result.success) {
          this.smartPavilions = res.data;
        } else {
          this.$message({
            message: res.result.message,
            type: 'warning'
          });
        }
      });
    },
    goSmartPavilionDetails(pavilion) {
      this.$router.push({path: '/smartPavilionDetails', query: { params: JSON.stringify(pavilion)}});
    },
  },
};
</script>


<style scoped>
.box_down {
  z-index: 888;
  position: fixed;
  top: 30px;
  left: 0;
  margin: 10px;
  width: calc(100% - 20px);
  height: calc(100% - 111px);
  overflow: auto;
}
</style>
